// apiService.ts
import axios from "axios";

const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
  
  headers: {
    "Content-Type": "application/json",
  },
});

export const SaveLeadDetails = async (payload: any) => {
  const response = await api.post("saveLeadDetails", payload);
  return response.data;
};



